<template>
  <div class="h-100 d-flex flex-column">
    <div class="container text-center" v-if="!loading">
      <div class="row pt-4 pb-3">
        <div class="col-sm">
            <h3>По всем возникшим вопросам пожалуйста пишите нам на почту</h3>
          <h4><a href="mailto:igorkaval85@gmail.com">igorkaval85@gmail.com</a></h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'HelpUser'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a{
  color:white;
}
</style>
